/**
 * Minimum number of characters required before triggering backend autocomplete.
 * Backend autocomplete is more expensive than client-side filtering,
 * so we require at least 2 characters to reduce noisy/broad queries.
 */
export const MIN_BACKEND_AUTOCOMPLETE_INPUT_LENGTH = 2;
